export enum EMPLOYEE_STATUS {
  ACTIVATED = 'ACTIVATED',
  DEACTIVATED = 'DEACTIVATED',
}

export enum EMPLOYEE_DOCUMENT_STATUS {
  UPLOADED = 'UPLOADED',
  NOT_UPLOADED = 'NOT UPLOADED',
}

export enum SELECTED_FIELD {
  PERSONAL = 'PERSONAL',
  EMPLOYMENT = 'EMPLOYMENT',
  CONTACT = 'CONTACT',
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  CAREER = 'CAREER',
  PAYROLL = 'PAYROLL',
  LEAVES = 'LEAVES',
  DOCUMENTS = 'DOCUMENTS',
}

export enum EMPLOYEE_REFERENCE_SECTION {
  EMPLOYEE = 'Employee',
}

export enum EMPLOYEE_REFERENCE_CATEGORIES {
  RELIGION = 'Religion',
  GENDER = 'Gender',
  MARITAL_STATUS = 'Marital Status',
  TYPES = 'Type',
  DEPARTMENTS = 'Department',
  CATEGORY = 'Employee Category',
  DESIGNATION = 'Designation',
  LOCATION = 'Location',
  RELATIONSHIP = 'Relationship',
  BANK = 'Bank',
  BRANCH = 'Branch',
  BRANCH_CODE = 'Branch Code',
}
export enum EMPLOYEE_RELATIONSHIP_PERSON_REFERENCE_CATEGORY_FIELD {
  RELATION = 'Relation',
}

export enum EMPLOYEE_GENDER_REFERENCE_CATEGORY_FIELD {
  NAME = 'Name',
}
export enum EMPLOYEE_RELIGION_REFERENCE_CATEGORY_FIELD {
  RELIGION = 'Religion',
}
export enum EMPLOYEE_TYPES_REFERENCE_CATEGORY_FIELD {
  EMPLOYEE_TYPES = 'Employee_Types',
}
export enum EMPLOYEE_DEPARTMENTS_REFERENCE_CATEGORY_FIELD {
  DEPARTMENT_NAME = 'Department',
}
export enum EMPLOYEE_BANK_REFERENCE_CATEGORY_FIELD {
  BANK = 'Bank',
}
export enum EMPLOYEE_BRANCH_REFERENCE_CATEGORY_FIELD {
  BRANCH = 'Branch',
  BANK = 'Bank',
  BRANCH_CODE = 'Branch Code',
}

export enum EMPLOYEE_CATEGORY_REFERENCE_CATEGORY_FIELD {
  DEPARTMENT = 'Department',
  CATEGORY = 'Category',
}
export enum EMPLOYEE_DESIGNATION_REFERENCE_CATEGORY_FIELD {
  CATEGORY = 'category',
  DESIGNATION = 'Designation',
}
export enum EMPLOYEE_LOCATION_REFERENCE_CATEGORY_FIELD {
  LOCATION = 'Location',
}
export enum EMPLOYEE_STATUS_REFERENCE_CATEGORY_FIELD {
  TYPE = 'Type',
}
export enum SELECTION_MODE {
  PLAIN = 'PLAIN',
  CHIPS = 'CHIPS',
}
